import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import coinImg from '../../img/hero/hero1-coin.png'
import coinImg2 from "../../img/others/cta1-mian-img.png"
import cta1 from "../../img/bg/cta1-shape-bg.png"
import cta2 from "../../img/shapes/blog-shape.png"
import authorImg from "../../img/icons/author.png"
import dateImg from "../../img/icons/date.png"
import blogImg from "../../img/blog/blog1-image3.png"
import blogImg5 from "../../img/blog/blog1-image2.png"
import blogImg6 from "../../img/blog/blog1-image1.png"
import mapimg from "../../img/testimonial/map.png"
import mapimg1 from "../../img/testimonial/tes1-img1.png"
import mapimg2 from "../../img/testimonial/tes1-img2.png"
import mapimg3 from "../../img/testimonial/tes1-img3.png"
import mapimg4 from "../../img/testimonial/tes1-img4.png"
import mapimg5 from "../../img/testimonial/tes1-img5.png"
import mapimg6 from "../../img/testimonial/tes1-img6.png"
import iconImg2 from "../../img/icons/tes1-icon.png"
import bankicon1 from "../../img/icons/bank1.svg"
import bankicon2 from "../../img/icons/bank2.svg"
import bankicon3 from "../../img/icons/bank3.svg"
import heromob from "../../img/hero/hero1-mobile1.png"
import heromob1 from "../../img/hero/hero1-mobile2.png"
import heromob2 from "../../img/hero/hero1-mobile3.png"
import heromain from "../../img/hero/hero1-main.png"
import app1 from "../../img/hero/app1.png"
import app2 from "../../img/hero/app2.png"
import appqr from "../../img/hero/qr.png"
import appARROW from "../../img/shapes/arrow.png"
import about1 from "../../img/bg/about1-shape-bg.png"
import about2 from "../../img/shapes/about1-shape.png"
import about3 from "../../img/about/about1-img1.png"
import about4 from "../../img/about/about1-img2.png"
import about5 from "../../img/about/about1-img3.png"
import abouticon1 from "../../img/icons/about1-icon1.svg"
import abouticon2 from "../../img/icons/about1-icon2.svg"
import fact from "../../img/icons/fact-icon1.svg"
import fact2 from "../../img/icons/fact-icon2.svg"
import fact3 from "../../img/icons/fact-icon3.svg"
import footerimg from "../../img/shapes/footer-shape2.png"
import footer5 from "../../img/shapes/footer-shape5.png"
import footer4 from "../../img/shapes/footer-shape4.png"
import footer1 from "../../img/shapes/footer-shape1.png"
import marketing from "../../img/logo/marketing-logo1.png"
import marketing2 from "../../img/logo/marketing-logo2.png"
import marketing3 from "../../img/logo/marketing-logo3.png"
import marketing4 from "../../img/logo/marketing-logo4.png"
import marketing5 from "../../img/logo/marketing-logo5.png"
import marketing6 from "../../img/logo/marketing-logo6.png"
import service from "../../img/icons/service1-icon1.svg"
import service1 from "../../img/icons/service1-icon2.svg"
import service2 from "../../img/service/service1-main-img.png"
import service3 from "../../img/service/service1-img-shape1.png"
import service4 from "../../img/service/service1-img-shape2.png"
import service5 from "../../img/shapes/service1-shape1.png"
import service6 from "../../img/shapes/service1-shape2.png"
import service7 from "../../img/shapes/service1-shape3.png"
import service8 from "../../img/shapes/service1-shape4.png"
import service9 from "../../img/icons/service1-icon3.svg"
import service10 from "../../img/icons/service1-icon4.svg"
import work from "../../img/work/work1-img1.png"
import work1 from "../../img/work/work1-img2.png"
import work2 from "../../img/work/work1-img3.png"
import appleicon from "../../img/others/apple-btn.png"
import gglicon from "../../img/others/goole-btn.png"
import mobbg from "../../img/bg/mobile-image-bg.png"
import mobarea from "../../img/others/mobile-area-img.png"
import mobareacoin from "../../img/others/mobile-area-coin.png"
import mobqr from "../../img/others/mobile-area-qr.png"
import mobshape from "../../img/shapes/mobile-area-shape.png"
import aboutpaycoin from "../../img/about/common-hero-coin.png"
import aboutpaycoin2 from "../../img/about/about-hero-area.png"
import marketicon from "../../img/icons/market-icon1.png"
import marketicon1 from "../../img/icons/market-i.png"
import marketicon2 from "../../img/icons/market-icon2.png"
import marketicon3 from "../../img/icons/market-icon3.png"
import marketicon4 from "../../img/icons/market-icon4.png"
import marketchart from "../../img/icons/market-chart1.png"
import marketchart1 from "../../img/icons/market-chart2.png"
import marketchart2 from "../../img/icons/market-chart3.png"

import { faStar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

SwiperCore.use([Navigation, Autoplay]);

const MarketUpdate = () => {

    useEffect(() => {
        AOS.init({
            duration: 800,  // You can set the duration here or directly in the HTML as data-aos-duration
        });
    }, []);

    return (
        <>
            <Header />
            <div class="common-hero" style={{ backgroundImage: `url(${require('../../img/bg/common-hero-bg.png')})` }}>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="main-heading">
                                <h1>Market Update</h1>
                                <div class="space16"></div>
                                <p>Investing in cryptocurrenciesan be exciting journey, but it's essential to approach it with caution and diligence.</p>
                                <div class="subscribe-form">
                                    <form action="#">
                                        <input type="email" placeholder="Email Address" />
                                        <div class="button">
                                            <button class="theme-btn1 btn btn--ripple ripple">Get Started <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} style={{ marginLeft: "5px" }} /></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <div class="common-hero-images">
                                <div class="image1">
                                    <img src={aboutpaycoin} alt="" />
                                </div>

                                <div class="image2">
                                    <img src={aboutpaycoin2} alt="" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div data-bs-spy="scroll" data-bs-target="#list-example" data-bs-offset="0" class="scrollspy-example" tabindex="0">
                <div class="market-page-sec1 sp">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-8 m-auto text-center">
                                <div class="heading1">
                                    <span class="span">Today Market update</span>
                                    <h2>Today’s Cryptocurrency prices</h2>
                                </div>
                            </div>
                        </div>
                        <div class="market-update-boxs">
                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="update-box">
                                        <div class="icon-area">
                                            <div class="icon">
                                                <img src={marketicon} alt="" />
                                            </div>
                                            <div class="heading">
                                                <h5>Estimated Balance</h5>
                                            </div>
                                        </div>
                                        <h3>$123,987</h3>
                                        <img src={marketicon1} alt="" class="ye" />

                                        <div class="bottom-area">
                                            <p class="author">Monthly Profit</p>
                                            <p class="up">+$2560.78</p>
                                            <p class="up-bg"><span>+14.67%</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3">
                                    <div class="update-box">
                                        <div class="icon-area">
                                            <div class="icon">
                                                <img src={marketicon2} alt="" />
                                            </div>
                                            <div class="heading">
                                                <h5>BTCUSDT</h5>
                                                <p>Bitcoin</p>
                                            </div>
                                        </div>
                                        <h3>$23,738</h3>
                                        <img src={marketchart} alt="" class="chart" />
                                        <div class="bottom-area">
                                            <p class="author">Monthly Profit</p>
                                            <p class="down">-$16.78</p>
                                            <p class="up-bg"><span>+14.67%</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3">
                                    <div class="update-box">
                                        <div class="icon-area">
                                            <div class="icon">
                                                <img src={marketicon3} alt="" />
                                            </div>
                                            <div class="heading">
                                                <h5>ETHUSDT</h5>
                                                <p>Ethereum</p>
                                            </div>
                                        </div>
                                        <h3>$23,738</h3>
                                        <img src={marketchart1} alt="" class="chart" />

                                        <div class="bottom-area">
                                            <p class="author">Monthly Profit</p>
                                            <p class="up">+$189.91</p>
                                            <p class="up-bg"><span>+14.67%</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3">
                                    <div class="update-box">
                                        <div class="icon-area">
                                            <div class="icon">
                                                <img src={marketicon4} alt="" />
                                            </div>
                                            <div class="heading">
                                                <h5>SOLUSDT</h5>
                                                <p>Solana</p>
                                            </div>
                                        </div>
                                        <h3>$23,738</h3>
                                        <img src={marketchart2} alt="" class="chart" />

                                        <div class="bottom-area">
                                            <p class="author">Monthly Profit</p>
                                            <p class="up">+$556.14</p>
                                            <p class="up-bg"><span>+14.67%</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="market-tab">

                        <div class="space60"></div>
                        <section class="coin-list">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="coin-list__main" data-aos="fade-up" data-aos-duration="800">
                                            <div class="flat-tabs">
                                                <div class="content-tab">
                                                    <div class="content-inner">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col"></th>
                                                                    <th scope="col">Name/Pair</th>
                                                                    <th scope="col">Last Price</th>
                                                                    <th scope="col">24 Change</th>
                                                                    <th scope="col">Chart</th>
                                                                    <th scope="col">Trade</th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr class="spacer">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><span class="icon-star"><FontAwesomeIcon icon={faStar} /></span></th>
                                                                    <td>
                                                                        <a href="#" style={{ marginTop: "25px" }}>
                                                                            <img src={marketing} alt="" />
                                                                            <span>BitCoin (BSTD)</span>
                                                                        </a>
                                                                    </td>
                                                                    <td class="boild" style={{ paddingTop: "35px" }}>$56,623.54</td>
                                                                    <td class="up" style={{ paddingTop: "35px" }}>+1.45%</td>
                                                                    <td><div id="total-revenue-chart-1"></div></td>
                                                                    <td><a href="#" class="btn" style={{ marginTop: "17px" }}>Trade</a></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr class="spacer">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><span class="icon-star"><FontAwesomeIcon icon={faStar} /></span></th>
                                                                    <td>
                                                                        <a href="#" style={{ marginTop: "25px" }}>
                                                                            <img src={marketing2} alt="" />
                                                                            <span>Ethereum (ETH)</span>
                                                                        </a>
                                                                    </td>
                                                                    <td class="boild" style={{ paddingTop: "35px" }}>$56,623.54</td>
                                                                    <td class="up" style={{ paddingTop: "35px" }}>-5.12%</td>
                                                                    <td><div id="total-revenue-chart-2"></div></td>
                                                                    <td><a href="#" class="btn" style={{ marginTop: "17px" }}>Trade</a></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr class="spacer">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><span class="icon-star"><FontAwesomeIcon icon={faStar} /></span></th>
                                                                    <td>
                                                                        <a href="#" style={{ marginTop: "25px" }}>
                                                                            <img src={marketing3} alt="" />
                                                                            <span>Binance (BNB)</span>
                                                                        </a>
                                                                    </td>
                                                                    <td class="boild" style={{ paddingTop: "35px" }}>$56,623.54</td>
                                                                    <td class="up" style={{ paddingTop: "35px" }}>-3.75%</td>
                                                                    <td><div id="total-revenue-chart-3"></div></td>
                                                                    <td><a href="#" class="btn" style={{ marginTop: "17px" }}>Trade</a></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr class="spacer">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><span class="icon-star"><FontAwesomeIcon icon={faStar} /></span></th>
                                                                    <td>
                                                                        <a href="#" style={{ marginTop: "25px" }}>
                                                                            <img src={marketing4} alt="" />
                                                                            <span>Tether (USDT)</span>
                                                                        </a>
                                                                    </td>
                                                                    <td class="boild" style={{ paddingTop: "35px" }}>$56,623.54</td>
                                                                    <td class="up" style={{ paddingTop: "35px" }}>+1.45%</td>
                                                                    <td><div id="total-revenue-chart-4"></div></td>
                                                                    <td><a href="#" class="btn" style={{ marginTop: "17px" }}>Trade</a></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr class="spacer">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><span class="icon-star"><FontAwesomeIcon icon={faStar} /></span></th>
                                                                    <td>
                                                                        <a href="#" style={{ marginTop: "25px" }}>
                                                                            <img src={marketing5} alt="" />
                                                                            <span>Solana (SOL)</span>
                                                                        </a>
                                                                    </td>
                                                                    <td class="boild" style={{ paddingTop: "35px" }}>$56,623.54</td>
                                                                    <td class="down" style={{ paddingTop: "35px" }}>+1.45%</td>
                                                                    <td><div id="total-revenue-chart-5"></div></td>
                                                                    <td><a href="#" class="btn" style={{ marginTop: "17px" }}>Trade</a></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr class="spacer">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><span class="icon-star"><FontAwesomeIcon icon={faStar} /></span></th>
                                                                    <td>
                                                                        <a href="#" style={{ marginTop: "25px" }}>
                                                                            <img src={marketing6} alt="" />
                                                                            <span>USD Coin (USDC)</span>
                                                                        </a>
                                                                    </td>
                                                                    <td class="boild" style={{ paddingTop: "35px" }}>   $56,623.54</td>
                                                                    <td class="down" style={{ paddingTop: "35px" }}>-2.22%</td>
                                                                    <td><div id="total-revenue-chart-6"></div></td>
                                                                    <td><a href="#" class="btn" style={{ marginTop: "17px" }}>Trade</a></td>

                                                                    <td></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                <div class="blog1 sp" id="blog">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 m-auto text-center">
                                <div class="heading1">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700">Our Blog</span>
                                    <h2 class="text-anime-style-3">Latest Blog & News</h2>
                                </div>
                            </div>
                        </div>

                        <div class="space30"></div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6" data-aos="zoom-in-up" data-aos-duration="800" data-aos-offset="100">
                                <div class="blog-box">
                                    <div class="image img100 image-anime">
                                        <img src={blogImg6} alt="" />
                                    </div>
                                    <div class="tags">
                                        <a href="#"><img src={authorImg} alt="" /> Alex Robertson</a>
                                        <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                    </div>
                                    <div class="heading1">
                                        <h5><a href="/blogDetail">The Power of Diversification in Cryptocurrency on Investment</a></h5>
                                        <div class="space16"></div>
                                        <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                        <div class="space16"></div>
                                        <a href="/blogDetail" class="learn">Read More <span> <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></span></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6" data-aos="zoom-in-up" data-aos-duration="1000" data-aos-offset="100">
                                <div class="blog-box">
                                    <div class="image img100 image-anime">
                                        <img src={blogImg5} alt="" />
                                    </div>
                                    <div class="tags">
                                        <a href="#"><img src={authorImg} alt="" /> Alex Robertson</a>
                                        <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                    </div>
                                    <div class="heading1">
                                        <h5><a href="/blogDetail">The Best Ultimate Crypto Trading Handbook: Strategies, Tips More</a></h5>
                                        <div class="space16"></div>
                                        <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                        <div class="space16"></div>
                                        <a href="/blogDetail" class="learn">Read More <span> <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></span></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6" data-aos="zoom-in-up" data-aos-duration="1100" data-aos-offset="100">
                                <div class="blog-box">
                                    <div class="image img100 image-anime">
                                        <img src={blogImg} alt="" />
                                    </div>
                                    <div class="tags">
                                        <a href="#"><img src={authorImg} alt="" /> Alex Robertson</a>
                                        <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                    </div>
                                    <div class="heading1">
                                        <h5><a href="/blogDetail">The Benefits of Diversification in Cryptocurrency Investment</a></h5>
                                        <div class="space16"></div>
                                        <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                        <div class="space16"></div>
                                        <a href="/blogDetail" class="learn">Read More <span> <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} /></span></a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <img src={cta2} alt="" class="shape" />
                </div>


            </div>
            <Footer />
        </>
    )
}

export default MarketUpdate